import { fullMonthDate } from "../../../../helpers/GetDuration";
import { formatFixedNumber } from "../../../../utilities/functions";
import classes from "./BarChartCustomTooltip.module.css"

const BarChartCustomTooltip = ({ active, payload, label, selectedOption }) => {
    if (active && payload && payload.length) {
      const drawdownValue = Number(payload[0]?.value);
      const formattedValue = formatFixedNumber(drawdownValue);

      return (
        <div className={`${classes.wrapper} gain-chart-tooltip-wrapper`}>
          <h6>Max Drawdown</h6>
          <h6>{fullMonthDate(payload[0]?.payload?.date)}</h6>
          <p className="label">{`${drawdownValue > 0 ? `-${formattedValue}` : formattedValue} USD`}</p>
          {/* <div>
            {payload.map((pld) => (
              <div style={{ display: "inline-block", padding: 10 }}>
                <div style={{ color: pld.fill }}>{pld.value}</div>
                <div style={{ color: "gray" }}>{pld.dataKey} drivers</div>
              </div>
            ))}
          </div> */}
        </div>
      );
    }
  
    return null;
  };

  export default BarChartCustomTooltip
